// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__PnZHp","badge":"tabs_badge__DlS13","badge-yellow":"tabs_badge-yellow__qYBq8","badge-green":"tabs_badge-green__U9UaI","badge-red":"tabs_badge-red__njgNR"};